import {IKbRecord} from "@kta20-knowledge-base/interfaces/i-kb-record";

export class KbEventRecord extends IKbRecord {

    static CLASS_NAME='KbEventRecord';

    readonly type:string=KbEventRecord.CLASS_NAME;

    creationDate:string;

}